import { DataKey, DataValueKey, TimeUnitKey } from 'types';

export const LOCATION_ID_KEY = 'location_id';
export const FORECAST_SCENARIO_ID_KEY = 'forecast_scenario_id';
export const YEAR_KEY = 'year';
export const DAY_KEY = 'day';
export const VALUE_KEY = 'value';
export const UPPER_KEY = 'upper';
export const LOWER_KEY = 'lower';
export const CAUSE_ID_KEY = 'cause_id';
export const DATA_PROJECT_ID_KEY = 'data_project_id';
export const COMORBID_CAUSE_ID_KEY = 'comorbid_cause_id';
export const CAUSE_PREVALENCE_KEY = 'cause_prevalence';
export const CAUSE_PREVALENCE_UPPER_KEY = 'cause_prevalence_upper';
export const CAUSE_PREVALENCE_LOWER_KEY = 'cause_prevalence_lower';
export const SEQUELA_ID_KEY = 'sequela_id';
export const REI_ID_KEY = 'rei_id';
export const RISK_EXPOSURE_ID_KEY = 'risk_exposure_id';
export const COVARIATE_ID_KEY = 'covariate_id';
export const SDOH_ID_KEY = 'sdoh_id';
export const POPULATION_ID_KEY = 'population_id';
export const LIFE_EXPECTANCY_ID_KEY = 'life_expectancy_id';
export const INFECTIOUS_SYNDROME_ID_KEY = 'infectious_syndrome_id';
export const ANTIBIOTIC_CLASS_ID_KEY = 'antibiotic_class_id';
export const COUNTERFACTUAL_ID_KEY = 'counterfactual_id';
export const PATHOGEN_ID_KEY = 'pathogen_id';
export const COVID19_ID_KEY = 'covid19_id';
export const AGE_GROUP_ID_KEY = 'age_group_id';
export const AGE_KEY = 'age';
export const AGE_MIN_KEY = 'age_min';
export const AGE_MAX_KEY = 'age_max';
export const AGE_GROUP_NAME_KEY = 'age_group_name';
export const GENDER_ID_KEY = 'gender_id';
export const METRIC_ID_KEY = 'metric_id';
export const MEASURE_ID_KEY = 'measure_id';
export const ROUND_ID_KEY = 'round_id';
export const MAP_DETAIL_LEVEL_ID_KEY = 'map_detail_level_id';
export const MAP_TYPE_ID_KEY = 'map_type_id';
export const MONTH_COUNT_KEY = 'month_count';
export const CAUSE_PREVALENCE_NUMBER = 'cause_prevalence_number';
export const COMORBID_CAUSE_CUMULATIVE_INCIDENCE_RATE = 'comorbid_cause_cumulative_incidence_rate';
export const INDICATOR_ID_KEY = 'indicator_id';
export const RACE_ID_KEY = 'race_id';
export const FACILITY_ID_KEY = 'facility_id';
export const INDUSTRY_ID_KEY = 'industry_id';
export const RESPONSE_ID_KEY = 'response_id';
export const ETHNICITY_ID_KEY = 'ethnicity_id';
export const EMPLOYMENT_COHORT_ID_KEY = 'employment_cohort_id';
export const EMPLOYMENT_STATUS_ID_KEY = 'employment_status_id';
export const PORTAL_ORGANIZATION_ID_KEY = 'portal_organization_id';
export const TREEMAP_DETAIL_LEVEL_ID_KEY = 'treemap_detail_level_id';
export const MULTIPLE_MYELOMA_TREATMENT_ID_KEY = 'multiple_myeloma_treatment_id';
export const EDUCATION_ID_KEY = 'education_id';
export const ORGANIZATION_ID_KEY = 'organization_id';
export const RESOURCE_ID_KEY = 'resource_id';
export const AGE_GROUP_RANGE_KEY = 'age_group_range';
export const VEHSS_CONDITION_ID_KEY = 'vehss_condition_id';
export const PARTICIPANTS_NUMBER_KEY = 'participants_number';
export const DATA_TYPE_KEY = 'data_type_id';
export const PRIMARY_ENTITY_KEY = 'primary_entity';
export const PRIMARY_ENTITY_ID_KEY = 'primary_entity_id';
export const PRIMARY_ENTITY_ID_LOCALIZATION_KEY = 'primary_entity_localization_key';
export const DATE_KEY = 'date';
export const WEEK_KEY = 'week';
export const START_DATE_KEY = 'start_date';
export const END_DATE_KEY = 'end_date';
export const RESCALED_HEATMAP_VALUE = 'rescaled_heatmap_value';
export const LNG_KEY = 'lng';
export const LAT_KEY = 'lat';
export const SERIES_NAME_KEY = 'series_name';
export const MAX_PROBABILITY_VALUE = 'max_probability_value';
export const MAX_PROBABILITY_LEVEL = 'max_probability_level';
export const MAX_PROBABILITY_CAUSE_ID = 'max_probability_cause_id';
export const UNDERLYING_CONDITION_KEY = 'underlying_condition';
export const CONDITION_LEVEL_KEY = 'condition_level';
export const VACCINE_STATUS_ID_KEY = 'vaccine_status_id';
export const DENGUE_ID_KEY = 'dengue_id';
export const CASE_SEVERITY_ID_KEY = 'case_severity_id';
export const CASE_HOSPITALIZATION_ID_KEY = 'case_hospitalization_id';
export const CASE_OUTCOME_ID_KEY = 'case_outcome_id';
export const SURVEY_ID_KEY = 'survey_id';
export const SURVEY_STATUS = 'survey_status';
export const QUESTION_ID_KEY = 'question_id';
export const OPTION_ID_KEY = 'option_id';
export const OPTION_COMMENT = 'option_comment';
export const RESPONDENT_KEY = 'respondent';
export const ORGANIZATION_KEY = 'organization';
export const CREATED = 'created';

export const INFECTION_TYPE_ID_KEY = 'infection_type_id';
export const SEROTYPE_ID_KEY = 'serotype_id';
export const VACCINATION_STATUS_ID_KEY = 'vaccination_status_id';
export const WOLBACHIA_INCLUDED_ID_KEY = 'wolbachia_included_id';
export const YEAR_START_KEY = 'year_start';
export const PAYER_ID_KEY = 'payer_id';
export const TOC_ID_KEY = 'toc_id';

export const getTimeUnitKeys = (): TimeUnitKey[] => [
    DAY_KEY,
    YEAR_KEY,
    MONTH_COUNT_KEY,
    START_DATE_KEY,
    END_DATE_KEY,
    WEEK_KEY,
];
export const isTimeUnitKey = (key: TimeUnitKey): boolean => getTimeUnitKeys().includes(key);
export const getValueKeys = (): DataValueKey[] => [VALUE_KEY, UPPER_KEY, LOWER_KEY];
export const isStringFilterValue = (key: DataKey): boolean => [DAY_KEY].includes(key);
